import { faFacebook, faLine } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default ({ type }) => (
  <footer className="footer">
    <span>
      <span className="text-bold">諮詢專線: </span>(02)2760-7768
    </span>
    <span>
      <span className="text-bold">E-mail: </span>service@etalkingonline.com
    </span>
    {
      type === 'kid' &&
      <span>
        <span className="text-bold">Web: </span><a href="http://etalking.com.tw" target="_blank">http://etalking.com.tw</a>
      </span>
    }
    {
      type === 'kidsnew' &&
      <span>
        <span className="text-bold">Web: </span><a href="http://etalking.com.tw" target="_blank">http://etalking.com.tw</a>
      </span>
    }
    {
      type !== 'kid' && type !== 'kidsnew' &&
      <span>
        <span className="text-bold">Web: </span><a href="https://www.etalkingonline.com" target="_blank">http://www.etalkingonline.com</a>
      </span>
    }
    <span>

      {
          type === 'kidsnew' &&
          <a href="https://www.facebook.com/etalkingkidsonline/" target="_blank">
              <FontAwesomeIcon
                  icon={faFacebook}
                  size="2x"
                  style={{
                      margin: "1rem"
                  }}
              />
          </a>
      }
      {
        type === 'kid' &&
        <a href="https://www.facebook.com/etalkingkidsonline/" target="_blank">
            <FontAwesomeIcon
                icon={faFacebook}
                size="2x"
                style={{
                    margin: "1rem"
                }}
            />
        </a>
      }
      {
        type !== 'kid' && type !== 'kidsnew' &&
        <a href="https://www.facebook.com/etalkingonline/" target="_blank">
            <FontAwesomeIcon
                icon={faFacebook}
                size="2x"
                style={{
                    margin: "1rem"
                }}
            />
        </a>
      }
      {
        type === 'kidsnew' &&
        <a href="https://line.me/R/ti/p/%40apa4737c" target="_blank">
            <FontAwesomeIcon
                icon={faLine}
                size="2x"
                style={{
                    margin: "1rem"
                }}
            />
        </a>
      }
      {
        type === 'kid' &&
        <a href="https://line.me/R/ti/p/%40apa4737c" target="_blank">
          <FontAwesomeIcon
            icon={faLine}
            size="2x"
            style={{
              margin: "1rem"
            }}
          />
        </a>
      }
      {
        type !== 'kid' && type !== 'kidsnew' &&
        <a href="https://lin.ee/cHSG1dh" target="_blank">
          <FontAwesomeIcon
            icon={faLine}
            size="2x"
            style={{
              margin: "1rem"
            }}
          />
        </a>
      }
    </span>
    <style jsx>{`
      footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 2em;
        background: #343434;
        color: #fff;
      }

      .text-bold {
        font-weight: 400;
        color: #bbc5c5;
      }

      footer > span {
        margin-right: 1em;
      }

      a {
        color: #fff;
      }

      @media(max-width: 768px){
        footer {
          flex-direction: column;
          padding: 2em 0;
        }

        span {
          margin: .5em;
        }
      }
    `}</style>
  </footer>
)
